<template>


    <app-layout :title="__('Ads')">


        <div class="">


            <div class="max-w-9xl mx-auto sm:px-6 lg:px-8">


                <div class="">


                    <div
                        style="grid-template-rows:  max-content minmax(50px, 90%) auto"
                        class="grid grid-cols-2">


                        <div class="my-4 row-start-1">


                            <h1 class="text-2xl font-nexa text-dark-blue h-[30px]">

                                Ads

                            </h1>


                        </div>

                        <div class="row-start-1 self-center justify-self-end flex">

                            <button class="mr-12 text-sm text-gray-600" @click="show_archived">

                                {{
                                    (showing_archived)
                                        ? 'Ads'
                                        : `Archive  (${ ads_archive_count })`
                                }}

                            </button>

                            <a class="p-2 px-4 my-3 bg-dark-blue items-center shadow-sm
                                flex cursor-pointer"
                                @click="create_new_ad">


                                <h1 class="text-sm font-nexa text-white">

                                    Create Ad

                                </h1>


                            </a>

                        </div>


                        <flash-message v-if="$page.props.flash.message"
                                       :message="$page.props.flash.message"
                                       classes="pl-6 text-green mb-6" />


                        <NordenTable
                            :headers="ads_headers"
                            :rows="ads_rows"
                            row_classes="hover:text-blue hover:underline cursor-pointer hover-underline"
                            @click_on_row="handle_click_on_row">

                            <template #restore="props" v-if="showing_archived">

                                <div class="flex">

                                    <div
                                         class="py-3 cursor-pointer bg-blue w-[75px] text-white text-center"
                                         @click.exact.stop="$inertia.patch( route('ad_restore', {
                                            ad_id: props.row.id,
                                        }) )">

                                        Restore

                                    </div>

                                </div>

                            </template>

                            <template #name="props">

                                <div style="margin-bottom: 16px;" class="leading-4">{{ props.row.name }}</div>

                                <div class="flex">

                                    <div class="mr-4"
                                        v-for="language of props.row.languages">

                                        <img :src="`/images/flag-${language.letter_code}.png`"
                                            class="rounded-full cursor-pointer "
                                            :class="{
                                                'opacity-100': language.status === 'active',
                                                'opacity-30': language.status !== 'active'
                                            }"
                                            alt="Flag"
                                            width="20"
                                            height="20"
                                            @click.exact.stop="$inertia.visit( route('ad', {
                                                ad: props.row.id,
                                                language: language.letter_code
                                            }) )"
                                        />

                                    </div>

                                </div>

                            </template>


                            <template #period="props">

                                <div>{{ props.row.period.start_at }} - {{ props.row.period.end_at }}</div>

                            </template>

                        </NordenTable>


                    </div>


                </div>


            </div>


        </div>


    </app-layout>


</template>


<script>
import { defineComponent } from 'vue'
import AppLayout from '../Layouts/AppLayout.vue'
import NordenTable from "@/Components/NordenTable";
import FlashMessage from "@/Components/FlashMessage";
import Button from "@/Jetstream/Button";

export default defineComponent({

    components: {
        Button,
        FlashMessage,
        NordenTable,
        AppLayout,
    },
    props: {
        ads: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'The Nordic Councils environmental award',
                        languages: [],
                        status: 'active',
                        thumbnail: '/storage/ad-manifest1.png',
                        campaign_titles: [
                            'Simple',
                            'Extended',
                            'Compact'
                        ],
                        period: [
                            '10/11/2021',
                            '24/11/2021'
                        ],
                        clicks: 102,
                        sent: 3,
                        last_sent: '11/11/2021 10:32:23'
                    },
                    {
                        id: 2,
                        name: 'Ny Nordisk Mad',
                        status: 'paused',
                        languages: [],
                        thumbnail: '/storage/ad-manifest2.png',
                        campaign_titles: [
                            'Simple',
                            'Extended',
                            'Compact',
                            'Summary'
                        ],
                        period: [
                            '14/11/2021',
                            '06/12/2021'
                        ],
                        clicks: 10,
                        sent: 1,
                        last_sent: '13/11/2021 10:32:23'
                    },
                ];
            }
        },
        showing_archived: {
            type: Boolean,
            default: false
        },
        ads_archive_count: {
            type: Number,
            default: 0
        }
    },

    computed: {

        ads_headers() {

            let
                is_showing = this.showing_archived,
                headers = [
                    {
                        type: 'status',
                        name: 'Status',
                        value_key: 'status',
                        text_key: 'status_text',
                        column_width: '75px',
                        class: 'text-center text-white hover-underline',
                        style: ''
                    },
                    {
                        type: 'image',
                        name: 'Thumbnail',
                        text_key: 'thumbnail',
                        value_key: 'thumbnail',
                        column_width: '100px',
                        class: 'hover-underline'
                    },
                    {
                        type: 'slot',
                        name: 'Ad Name',
                        value_key: 'name',
                        text_key: 'name_html',
                        column_width: 4,
                        class: 'hover-underline'
                    },
                    {
                        name: 'Campaigns',
                        value_key: 'campaign_titles',
                        text_key: 'campaigns_text',
                        column_width: '150px',
                        class: 'hover-underline'
                    },
                    {
                        type: 'slot',
                        name: 'Period',
                        value_key: 'period',
                        text_key: 'period_text',
                        column_width: '115px',
                        class: 'hover-underline'
                    },
                    {
                        name: 'Clicks',
                        value_key: 'clicks',
                        text_key: 'clicks',
                        column_width: '60px',
                        class: 'hover-underline'
                    },
                    {
                        name: 'Sent',
                        value_key: 'sent',
                        text_key: 'sent_text',
                        column_width: '65px',
                        class: 'hover-underline'
                    },
                    {
                        name: 'Last Sent',
                        value_key: 'last_sent',
                        text_key: 'last_sent',
                        column_width: '170px',
                        class: 'hover-underline'
                    },
                ]
            ;


            if ( is_showing ) {

                headers.unshift({
                    type: 'slot',
                    name: '',
                    value_key: 'restore',
                    text_key: 'restore',
                    column_width: '75px',
                    class: 'hover-underline'
                });

            } else {

                // headers.shift();

            }


            return headers;

        },
        ads_rows() {

            return _.map(this.ads, (ads) => {

                ads.campaigns_text = this.campaigns_as_text(ads.campaign_titles);

                ads.sent_text = this.sent_as_text(ads.sent);

                ads.status_text = this.status_as_text(ads.status);

                return ads;

            });

        },

    },


    methods: {
        status_as_text(status) {

            if ( status === 'active' ) {

                return this.__('Active');

            }
            if ( status === 'paused' ) {

                return this.__('Paused');

            }

            return this.__('New');

        },

        campaigns_as_text(campaigns) {

            campaigns = campaigns.join(", ");

            return campaigns;

        },

        sent_as_text(sent) {

            sent = sent + " times";

            return sent;

        },

        show_archived() {

            if (this.showing_archived !== true) {

                this.$inertia.visit(
                    this.route('ads', {
                        show_archived: true
                    })
                );

            } else {

                this.$inertia.visit(
                    this.route('ads', {
                    })
                );

            }

        },


        handle_click_on_row(ad) {

            this.$inertia.visit(
                this.route('ad', {
                    ad: ad.id,
                    language: ad.languages[0].letter_code
                })
            );

        },

        create_new_ad() {

            this.$inertia.post(
                this.route('ads')
            );

        },

    }

})
</script>
